import { Component } from '@angular/core';

@Component({
  selector: 'age-icon',
  standalone: true,
  imports: [],
  templateUrl: './age.component.html',
  styleUrl: './age.component.scss'
})
export class AgeIcon {

}
